import React from "react"
import Relay from "react-relay"
import { filter } from "lodash/collection"
import Icon from "./Icon"
import { formatBytes } from "../../scripts/utils"
import { trackDownload } from "../../analyticsAndSocial"
import { FormattedMessage } from "react-intl"
import shareMessages from "../../messages/share"

class AudioDownload extends React.Component {
  render() {
    const { resource, audioFile } = this.props

    const files = filter(resource.files, { type: "audio" })
    const file = audioFile ? audioFile : files && files[0]
    const audio =
      file && file.audio && "lossy" in file.audio && file.audio["lossy"]
    const audioSrc = audio && audio.url

    return audioSrc ? (
      <ul className="list--unstyled list--accentuated">
        <li>
          <a
            href={audioSrc}
            onClick={e => trackDownload(this.eventLabel())}
            download
            target="_blank"
          >
            <Icon icon="download" />
            <FormattedMessage {...shareMessages.downloadAudio} />
            <small className="small--style inline-block">
              ({audio.mime_type}, {formatBytes(file.size, 0)})
            </small>
          </a>
        </li>
      </ul>
    ) : null
  }

  eventLabel = () => {
    const {
      resource: { type, title, id }
    } = this.props
    return `${type}-${id}-${title}`
  }
}

export default Relay.createContainer(AudioDownload, {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
      id
      title
      type
      files {
          type
          size
          audio {
              lossy {
                  url
                  mime_type
              }
            }
      }
  }
  `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/AudioDownload.js